import React, { useEffect } from "react";
import {
  ActiveParticipantsContainer,
  MentorHeading,
  MentorHeader,
  Info,
  Image,
  Name,
  Actions,
  InfoTitle,
  Meta,
  MenteeHeader,
  ParticipantsContainer,
  UnassignedList,
  UnassignedContainer,
  ViewChatIconContainer,
  UnassignedActionContainer,
  ActiveParticipantsWrapper,
  ParticipantsContainerInner,
  DropDownToggle,
  UnAssignButtonContainer,
  DropIcon,
  DropdownItems,
  DropdownButton,
} from "./styles";
import { useNavigate, useParams } from "react-router-dom";
import callAPI from "../../../../../../api/apiCaller";
import Accordian from "../../../../../../common/Accordian";
import Button from "../../../../../../common/Button";
import { ButtonSpacer } from "../../../../../../common/Button/styles";
import Loading from "../../../../../../common/Loading";
import Icon from "../../../../../../common/Icon";
import ReassignMentee from "../../../popups/ReassignMentee";
import { Context } from "../../../../../../Store";
import UserInfo from "../../../popups/UserInfo";
import TeamParticipant from "../../../TeamParticipant";
import Modal from "../../../../../../common/Modal";
import { SectionActions } from "../../../../Profile/LoginSecurity/styles";
import SpecificTeam from "../../MyTeams/SpecificTeam";
import MyTeams from "../../MyTeams";
import MatchMaking from "../../../popups/MatchMaking";

const ActiveParticipants = ({
  searchText,
  specificTeamProgram,
  setSpecificTeamProgram,
  setMentorMenteeData,
  setunassignedMenteeData,
  setStoredFilterFunction,
  setStoredAllFunction,
  setFilterLoader,
  setResetLoader,
}) => {
  React.useEffect(() => {
    programInformation();
  }, []);
  const params = useParams();
  const navigate = useNavigate();
  const [mentorParticipants, setMentorParticipants] = React.useState(null);
  const [mentorSearchParticipants, setMentorSearchParticipants] =
    React.useState(null);
  const [participants, setParticipants] = React.useState(null);
  const [isReassignOpen, setIsReassignOpen] = React.useState(false);
  const [isReassignOpenTeam, setIsReassignOpenTeam] = React.useState(false);
  const [isViewOpen, setIsViewOpen] = React.useState(false);
  const [refreshParticipants, setRefreshParticipants] = React.useState(false);
  const [isDeleteMember, setIsDeletMember] = React.useState(false);
  const [program, setProgram] = React.useState([]);
  const [teams, setTeams] = React.useState([]);
  const [pageSize, setPageSize] = React.useState(20);
  const [loading, setLoading] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(1);

  const [pageSizeUnAssigned, setPageSizeUnAssigned] = React.useState(20);
  const [loadingUnAssigned, setLoadingUnAssigned] = React.useState(false);
  const [pageUnAssigned, setPageUnAssigned] = React.useState(1);
  const [totalPagesUnAssigned, setTotalPagesUnAssigned] = React.useState(1);
  const [actionButtons, setActionButtons] = React.useState(null);
  const [actionButtonsMentee, setActionButtonsMentee] = React.useState(null);
  const [openReassignModal, setOpenReassignModal] = React.useState(false);
  const [clickedMentee, setClickedMentee] = React.useState(null);
  const [matchedParticipants, setMatchedParticipants] = React.useState([]);
  const Participants = (data) => {
    let activeParticipants = [];

    data?.unAssignedMentees
      ? (activeParticipants = [
          { name: "unAssignedMentees", mentees: data?.unAssignedMentees },
        ])
      : (activeParticipants = [
          { name: "unAssignedMentees", mentees: data?.unAssignedMembers },
        ]);

    return activeParticipants;
  };

  const { state, dispatch } = React.useContext(Context);

  const programInformation = () => {
    callAPI(dispatch, "getProgramInformation", {
      id: params.selectedProgram,
    }).then((info) => {
      setProgram(info.data);
    });
  };

  const getParticipant = () => {
    callAPI(dispatch, "getUnAssignedProgramParticipants", {
      id: params.selectedProgram,
      page: pageUnAssigned,
      take: pageSizeUnAssigned,
    }).then((res) => {
      if (res) {
        const data = Participants(res.data.active);
        const filterData = data?.filter((mentor) => {
          if (mentor.name === "unAssignedMentees") {
            return true;
          }
          return false;
        });
        setParticipants(Participants(res.data.active));
        setTotalPagesUnAssigned(res.data.totalPages);

        if (setunassignedMenteeData) {
          setunassignedMenteeData(filterData[0].mentees);
        }
      }
    });
  };

  const getSearchMentorHandler = (mentorName, status) => {
    const data = {
      id: params.selectedProgram,
      search: mentorName === undefined ? null : mentorName,
      status: status === undefined ? null : status,
    };
    callAPI(dispatch, "getSearchMentorProgramParticipants", data)
      .then((res) => {
        setMentorSearchParticipants(res?.data?.active);

        const filterData = res?.data?.active?.mentors?.filter((mentor) => {
          // Exclude unassigned mentees
          if (mentor?.name === "unAssignedMentees") return false;

          if (searchText === "") return true; // ✅ include all if search is empty

          const matchMentor = mentor.participant.firstName
            .toLowerCase()
            .includes(searchText.toLowerCase());

          const matchMentee = mentor.mentees?.some((mentee) =>
            mentee.participant.firstName
              ?.toLowerCase()
              .includes(searchText.toLowerCase())
          );

          return matchMentor || matchMentee;
        });
        if (setMentorMenteeData) {
          setMentorMenteeData(filterData);
        }
      })
      .finally(() => {
        if (setFilterLoader) {
          setFilterLoader(false);
        }

        if (setResetLoader) {
          setResetLoader(false);
        }
      });
  };

  useEffect(() => {
    if (setStoredFilterFunction) {
      setStoredFilterFunction(() => getSearchMentorHandler);
    }

    if (setStoredAllFunction) {
      setStoredAllFunction(() => getSearchMentorHandler);
    }
  }, []);

  const getMentorParticipant = () => {
    callAPI(dispatch, "getMentorProgramParticipants", {
      id: params.selectedProgram,
      page: page, // Use updated page value
      take: pageSize,
    }).then((res) => {
      if (res) {
        setMentorParticipants(res?.data?.active);
        setTotalPages(res?.data?.totalPages);
      }
    });

    getSearchMentorHandler();
  };

  const filteredMentors = mentorSearchParticipants?.mentors?.filter(
    (mentor) => {
      // Exclude unassigned mentees
      if (mentor?.name === "unAssignedMentees") return false;

      if (searchText === "") return true; // ✅ include all if search is empty

      const matchMentor = mentor.participant.firstName
        .toLowerCase()
        .includes(searchText.toLowerCase());

      const matchMentee = mentor.mentees?.some((mentee) =>
        mentee.participant.firstName
          ?.toLowerCase()
          .includes(searchText.toLowerCase())
      );

      return matchMentor || matchMentee;
    }
  );

  // console.log("filteredMentors:", filteredMentors);

  function getMyTeam() {
    callAPI(dispatch, "getMyteams", {
      id: params.selectedProgram,
    }).then((res) => {
      setTeams(res?.data);
    });
  }

  function deleteProgram(id, userId) {
    callAPI(dispatch, "DeleteMember", {
      id: id,
      pid: +params.selectedProgram,
      userId,
    }).then(() => {
      setIsDeletMember(false);
      getParticipant();
      getMentorParticipant();
    });
  }

  const handleScrollUnAssigned = async (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (
      scrollTop + clientHeight + 3 >= scrollHeight &&
      !loadingUnAssigned &&
      pageUnAssigned < totalPagesUnAssigned
    ) {
      setLoadingUnAssigned(true);
      setPageUnAssigned((prevPage) => prevPage + 1); // Update page using a callback
      callAPI(dispatch, "getUnAssignedProgramParticipants", {
        id: params.selectedProgram,
        page: pageUnAssigned + 1, // Use updated page value
        take: pageSizeUnAssigned,
      }).then((res) => {
        if (res?.data?.active?.unAssignedMentees) {
          const updatedState = participants.map((participant) => {
            if (participant.name === "unAssignedMentees") {
              return {
                ...participant,
                mentees: [
                  ...participant.mentees,
                  ...res.data.active.unAssignedMentees,
                ],
              };
            }
            return participant;
          });
          setParticipants(updatedState);
        } else {
          const updatedState = participants.map((participant) => {
            if (participant.name === "unAssignedMentees") {
              return {
                ...participant,
                mentees: [
                  ...participant.mentees,
                  ...res.data.active.unAssignedMembers,
                ],
              };
            }
            return participant;
          });
          setParticipants(updatedState);
        }
        setLoadingUnAssigned(false);
      });
    }
  };

  const handleScroll = async (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (
      scrollTop + clientHeight + 3 >= scrollHeight &&
      !loading &&
      page < totalPages
    ) {
      setLoading(true);
      setPage((prevPage) => prevPage + 1); // Update page using a callback
      callAPI(dispatch, "getMentorProgramParticipants", {
        id: params.selectedProgram,
        page: page + 1, // Use updated page value
        take: pageSize,
      }).then((res) => {
        setMentorParticipants((prevState) => ({
          mentors: [...prevState.mentors, ...res?.data?.active?.mentors],
        }));
        setLoading(false);
      });
    }
  };

  React.useEffect(() => {
    getMyTeam();
    setParticipants(null);
    setMentorParticipants(null);
    getParticipant();
    getMentorParticipant();
  }, [refreshParticipants]);

  if (mentorParticipants === null) {
    return (
      <ActiveParticipantsContainer>
        <Loading loadingItem="Participants" />
      </ActiveParticipantsContainer>
    );
  }

  if (participants === null) {
    return (
      <ActiveParticipantsContainer>
        <Loading loadingItem="Participants" />
      </ActiveParticipantsContainer>
    );
  }

  const deactivateMentorAndUnassignMantes = (mentor) => {
    callAPI(dispatch, "deactivateMentorAndUnassignMantess", {
      programId: mentor?.programId,
      mentorId: mentor?.id,
      menteesIds: mentor?.mentees?.map((mentee) => mentee.id),
    })
      .then((res) => {
        getParticipant();
        getMentorParticipant();
      })
      .finally(() => {
        setActionButtons(null);
      });
  };

  const deleteMentorAndUnassignMantes = (mentor) => {
    //should send mentor id and participants id and at the backend soft delete mentor
    // and remove participant id of mantes so that they will be un assigned
    // setLoading(true);
    callAPI(dispatch, "deleteMentorAndUnassignMantees", {
      programId: mentor?.programId,
      userId: mentor?.participantId,
      mentorId: mentor?.id,
      menteesIds: mentor?.mentees?.map((mentee) => mentee.id),
    })
      .then((res) => {
        getParticipant();
        getMentorParticipant();
      })
      .finally(() => {
        setActionButtons(null);
      });
  };

  function deactivateMentee(id, userId) {
    callAPI(dispatch, "DeactivateProgram", {
      id: id,
      pid: +params.selectedProgram,
      userId: userId,
    })
      .then(() => {
        getParticipant();
        getMentorParticipant();
      })
      .finally(() => {
        setActionButtonsMentee(null);
      });
  }

  function unassignMentee(mentee) {
    callAPI(dispatch, "UnassignMentee", {
      programId: mentee?.programId,
      userId: mentee?.id,
    })
      .then(() => {
        getParticipant();
        getMentorParticipant();
      })
      .finally(() => {
        setActionButtonsMentee(null);
      });
  }

  return (
    <ActiveParticipantsWrapper>
      <ActiveParticipantsContainer>
        {program && program?.programType === "TEAM" ? (
          <ParticipantsContainer>
            <TeamParticipant
              searchText={searchText}
              setSpecificProgram={setSpecificTeamProgram}
              specificTeamProgram={specificTeamProgram}
            />
          </ParticipantsContainer>
        ) : (
          <ParticipantsContainer scrollStyle={true}>
            <MentorHeading>
              {program?.programType === "OPEN_NETWORK"
                ? "Meetings that have Occurred"
                : "Assigned Mentors and Mentees"}
            </MentorHeading>
            <ParticipantsContainerInner onScroll={handleScroll}>
              <Accordian
                multiOpen={true}
                isParticipants={true}
                defaultOpen={false}
                height={false}
                isAlign={true}
                sections={
                  filteredMentors &&
                  filteredMentors?.map((mentor) => {
                    return {
                      title: (
                        <MentorHeader>
                          <Info>
                            {
                              <Image
                                src={
                                  mentor.participant.image
                                    ? mentor.participant.image
                                    : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                                }
                              />
                            }
                            <Name>
                              {`${mentor?.participant.firstName} ${mentor?.participant.lastName}`}
                              <InfoTitle>Mentor</InfoTitle>
                            </Name>
                          </Info>
                          {mentor.participant.firstName !=
                            "unAssignedMentees" && (
                            <>
                              <Actions>
                                <Meta>
                                  Total Tracked Hours : {mentor.totalTrackHours}{" "}
                                  | Total Mentees: {mentor.mentees.length}
                                </Meta>
                              </Actions>
                              <ViewChatIconContainer
                                onMouseLeave={() => setActionButtons(null)}
                                isSet={true}
                              >
                                <DropIcon
                                  onClick={() =>
                                    setActionButtons((prev) =>
                                      prev === mentor.participant.id
                                        ? null
                                        : mentor.participant.id
                                    )
                                  }
                                >
                                  <Icon type="dropdown-dots" />
                                </DropIcon>
                                {actionButtons === mentor.participant.id && (
                                  <DropdownItems>
                                    <DropdownButton
                                      meetings={true}
                                      onClick={() => {
                                        setIsViewOpen(mentor.participantId);
                                      }}
                                    >
                                      <Icon type={"view"} color="#302F2F" />
                                      View More
                                    </DropdownButton>
                                    <DropdownButton
                                      meetings={true}
                                      variant="secondary"
                                      onClick={() => {
                                        callAPI(
                                          dispatch,
                                          "initializeConversation",
                                          {
                                            id: mentor?.participant?.id,
                                          }
                                        )
                                          .then((res) => {
                                            if (res) {
                                              navigate(
                                                `/messages/${mentor?.participant?.uuid}`
                                              );
                                            }
                                          })
                                          .catch((error) => {
                                            //console.error(error);
                                          });
                                      }}
                                    >
                                      <Icon type={"chat"} color="#302F2F" />
                                      Send Message
                                    </DropdownButton>
                                    <DropdownButton
                                      meetings={true}
                                      onClick={() => {
                                        deactivateMentorAndUnassignMantes(
                                          mentor
                                        );
                                      }}
                                    >
                                      <Icon
                                        type={
                                          mentor?.status === "active"
                                            ? "hide"
                                            : "view"
                                        }
                                        color="#302F2F"
                                      />
                                      {mentor?.status === "active"
                                        ? "Deactivate"
                                        : "Activate"}
                                    </DropdownButton>
                                    <DropdownButton
                                      meetings={true}
                                      variant="secondary"
                                      // onClick={() => setIsDeleteModal(row)}
                                      onClick={() =>
                                        deleteMentorAndUnassignMantes(mentor)
                                      }
                                    >
                                      <Icon type={"trash"} color="#302F2F" />
                                      Delete
                                    </DropdownButton>
                                  </DropdownItems>
                                )}
                                {/* <DropDownToggle><Icon type="dropdownIcon" /></DropDownToggle> */}
                              </ViewChatIconContainer>
                            </>
                          )}
                        </MentorHeader>
                      ),
                      content: (
                        <>
                          {mentor.mentees.length !== 0 &&
                            mentor.mentees
                              .filter((mentee) => {
                                if (
                                  mentor.participant.firstName
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                ) {
                                  return true;
                                }
                                if (
                                  mentee.participant.firstName
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                ) {
                                  return true;
                                }
                              })
                              .map((mentee) => {
                                {/* console.log("Mentee:", mentee); */}

                                return (
                                  <>
                                    {mentee && mentee?.recipientId && (
                                      <MenteeHeader>
                                        <Info>
                                          {
                                            <Image
                                              src={
                                                mentee.participant.image
                                                  ? mentee.participant.image
                                                  : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                                              }
                                            />
                                          }
                                          <Name>
                                            {mentee.participant.firstName +
                                              " " +
                                              mentee.participant.lastName}
                                            <InfoTitle>Mentee</InfoTitle>
                                          </Name>
                                        </Info>
                                        <Actions>
                                          <Meta>
                                            Tracked Hours :{" "}
                                            {mentee.trackedHours}
                                          </Meta>
                                          <ButtonSpacer />
                                        </Actions>
                                        {mentee.deletedAt &&
                                        mentee?.status === "active" ? (
                                          <ViewChatIconContainer
                                            isDeletedAt={true}
                                          ></ViewChatIconContainer>
                                        ) : (
                                          <ViewChatIconContainer>
                                            <div
                                              onMouseLeave={() =>
                                                setActionButtonsMentee(null)
                                              }
                                            >
                                              <DropIcon
                                                onClick={() =>
                                                  setActionButtonsMentee(
                                                    (prev) =>
                                                      prev ===
                                                      mentee.participant.id
                                                        ? null
                                                        : mentee.participant.id
                                                  )
                                                }
                                              >
                                                <Icon type="dropdown-dots" />
                                              </DropIcon>
                                              {actionButtonsMentee ===
                                                mentee.participant.id && (
                                                <DropdownItems>
                                                  <DropdownButton
                                                    meetings={true}
                                                    onClick={() => {
                                                      setIsViewOpen(
                                                        mentee.participantId
                                                      );
                                                    }}
                                                  >
                                                    <Icon
                                                      type={"view"}
                                                      color="#302F2F"
                                                    />
                                                    View More
                                                  </DropdownButton>
                                                  <DropdownButton
                                                    meetings={true}
                                                    variant="secondary"
                                                    onClick={() => {
                                                      callAPI(
                                                        dispatch,
                                                        "initializeConversation",
                                                        {
                                                          id: mentee
                                                            ?.participant?.id,
                                                        }
                                                      )
                                                        .then((res) => {
                                                          if (res) {
                                                            navigate(
                                                              `/messages/${mentee?.participant?.uuid}`
                                                            );
                                                          }
                                                        })
                                                        .catch((error) => {
                                                          //console.error(error);
                                                        });
                                                    }}
                                                  >
                                                    <Icon
                                                      type={"chat"}
                                                      color="#302F2F"
                                                    />
                                                    Send Message
                                                  </DropdownButton>

                                                  <DropdownButton
                                                    meetings={true}
                                                    variant="secondary"
                                                    onClick={() =>
                                                      deactivateMentee(
                                                        mentee?.id,
                                                        mentee?.participantId
                                                      )
                                                    }
                                                  >
                                                    <Icon
                                                      type={
                                                        mentee?.status ===
                                                        "active"
                                                          ? "hide"
                                                          : "view"
                                                      }
                                                      color="#302F2F"
                                                    />
                                                    {mentee?.status === "active"
                                                      ? "Deactivate"
                                                      : "Activate"}
                                                  </DropdownButton>

                                                  <DropdownButton
                                                    meetings={true}
                                                    variant="secondary"
                                                    onClick={() => {
                                                      deleteProgram(
                                                        mentee?.id,
                                                        mentee?.participantId
                                                      );
                                                    }}
                                                  >
                                                    <Icon
                                                      type={"trash"}
                                                      color="#302F2F"
                                                    />
                                                    Delete
                                                  </DropdownButton>

                                                  <DropdownButton
                                                    meetings={true}
                                                    variant="secondary"
                                                    onClick={() =>
                                                      unassignMentee(mentee)
                                                    }
                                                  >
                                                    <Icon
                                                      type={"user"}
                                                      color="#302F2F"
                                                    />
                                                    Unassign
                                                  </DropdownButton>
                                                </DropdownItems>
                                              )}
                                            </div>
                                            <ButtonSpacer />
                                            {program &&
                                              program?.programType ===
                                                "1_1_NETWORK" &&
                                              mentee?.status === "active" && (
                                                <Button
                                                  text="Reassign"
                                                  variant="primary"
                                                  borderRadius="5px"
                                                  onClick={() => {
                                                    setIsReassignOpen(mentee);
                                                  }}
                                                />
                                              )}
                                          </ViewChatIconContainer>
                                        )}
                                      </MenteeHeader>
                                    )}
                                  </>
                                );
                              })}
                        </>
                      ),
                    };
                  })
                }
              />
              {loading && (
                <Loading loadingItem="participants" isLoading={true} />
              )}
            </ParticipantsContainerInner>
          </ParticipantsContainer>
        )}

        <UnassignedContainer
          scrollStyle={true}
          onScroll={handleScrollUnAssigned}
        >
          <MentorHeading>
            {program.programType === "OPEN_NETWORK"
              ? "All Mentees"
              : program.programType === "TEAM"
              ? "Unassigned Member"
              : "Unassigned Mentees"}
            {program.programType !== "TEAM" ? (
              <Icon type={"magic-wand"} size="25" />
            ) : (
              ""
            )}
          </MentorHeading>

          <UnassignedList>
            {participants &&
              participants
                .filter((mentor) => {
                  if (mentor.name === "unAssignedMentees") {
                    return true;
                  }
                  return false;
                })
                .map((mentor) => {
                  return (
                    <>
                      {mentor?.mentees?.length !== 0 &&
                        mentor?.mentees
                          .filter((mentee) => {
                            if (
                              program.programType !== "TEAM" &&
                              mentee?.participant?.firstName
                                .toLowerCase()
                                .includes(searchText.toLowerCase())
                            ) {
                              return true;
                            } else return true;
                          })
                          .map((mentee) => {
                            return (
                              <>
                                {mentee && !mentee?.recipientId && (
                                  <MenteeHeader>
                                    <Info>
                                      {
                                        <Image
                                          src={
                                            mentee?.participant?.image
                                              ? mentee?.participant?.image
                                              : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                                          }
                                        />
                                      }
                                      <Name>
                                        {mentee?.participant?.firstName +
                                          " " +
                                          mentee?.participant?.lastName}
                                        <Meta>
                                          <InfoTitle>
                                            {program.programType === "TEAM"
                                              ? ""
                                              : "Mentee"}
                                          </InfoTitle>
                                        </Meta>
                                      </Name>
                                    </Info>

                                    <Actions>
                                      <Meta>
                                        Tracked Hours :{" "}
                                        {mentee.trackedHours
                                          ? mentee.trackedHours
                                          : 0}
                                      </Meta>
                                      <ButtonSpacer />
                                    </Actions>
                                    {program &&
                                      program?.programType ===
                                        "1_1_NETWORK" && (
                                        <>
                                          <UnAssignButtonContainer
                                            onMouseLeave={() =>
                                              setActionButtonsMentee(null)
                                            }
                                          >
                                            <DropIcon
                                              onClick={() =>
                                                setActionButtonsMentee((prev) =>
                                                  prev === mentee.participant.id
                                                    ? null
                                                    : mentee.participant.id
                                                )
                                              }
                                            >
                                              <Icon type="dropdown-dots" />
                                            </DropIcon>
                                            {actionButtonsMentee ===
                                              mentee.participant.id && (
                                              <DropdownItems>
                                                <DropdownButton
                                                  meetings={true}
                                                  onClick={() => {
                                                    setIsViewOpen(
                                                      mentee.participantId
                                                    );
                                                  }}
                                                >
                                                  <Icon
                                                    type={"view"}
                                                    color="#302F2F"
                                                  />
                                                  View More
                                                </DropdownButton>
                                                <DropdownButton
                                                  meetings={true}
                                                  variant="secondary"
                                                  onClick={() => {
                                                    callAPI(
                                                      dispatch,
                                                      "initializeConversation",
                                                      {
                                                        id: mentee?.participant
                                                          ?.id,
                                                      }
                                                    )
                                                      .then((res) => {
                                                        if (res) {
                                                          navigate(
                                                            `/messages/${mentee?.participant?.uuid}`
                                                          );
                                                        }
                                                      })
                                                      .catch((error) => {
                                                        //console.error(error);
                                                      });
                                                  }}
                                                >
                                                  <Icon
                                                    type={"chat"}
                                                    color="#302F2F"
                                                  />
                                                  Send Message
                                                </DropdownButton>
                                                <DropdownButton
                                                  meetings={true}
                                                  variant="secondary"
                                                  onClick={() =>
                                                    deactivateMentee(
                                                      mentee?.id,
                                                      mentee?.participantId
                                                    )
                                                  }
                                                >
                                                  <Icon
                                                    type={
                                                      mentee?.status ===
                                                      "active"
                                                        ? "hide"
                                                        : "view"
                                                    }
                                                    color="#302F2F"
                                                  />
                                                  {mentee?.status === "active"
                                                    ? "Deactivate"
                                                    : "Activate"}
                                                </DropdownButton>
                                                <DropdownButton
                                                  meetings={true}
                                                  variant="secondary"
                                                  onClick={() => {
                                                    deleteProgram(
                                                      mentee?.id,
                                                      mentee?.participantId
                                                    );
                                                  }}
                                                >
                                                  <Icon
                                                    type={"trash"}
                                                    color="#302F2F"
                                                  />
                                                  Delete
                                                </DropdownButton>
                                              </DropdownItems>
                                            )}
                                          </UnAssignButtonContainer>
                                          {mentee?.status === "active" && (
                                            <Button
                                              className={"reassignBtn"}
                                              text="Assign"
                                              variant="primary"
                                              borderRadius="5px"
                                              onClick={() => {
                                                setIsReassignOpen(mentee);
                                              }}
                                            />
                                          )}
                                        </>
                                      )}
                                    {program &&
                                      program?.programType === "TEAM" && (
                                        <>
                                          <Button
                                            text="Assign"
                                            variant="primary"
                                            onClick={() => {
                                              setIsReassignOpenTeam(
                                                mentee?.participantId
                                              );
                                            }}
                                          />
                                        </>
                                      )}
                                  </MenteeHeader>
                                )}
                              </>
                            );
                          })}
                    </>
                  );
                })}
            {loadingUnAssigned && (
              <Loading loadingItem="participants" isLoading={true} />
            )}
          </UnassignedList>
        </UnassignedContainer>

        {/* {isReassignOpen && ( */}
        {openReassignModal && (
          <ReassignMentee
            matchedParticipants={matchedParticipants}
            setMatchedParticipants={setMatchedParticipants}
            menteeId={openReassignModal}
            mentee={clickedMentee}
            closeModal={() => {
              setRefreshParticipants(!refreshParticipants);
              setOpenReassignModal(false);
            }}
          />
        )}
        {isReassignOpen && (
          <MatchMaking
            matchedParticipants={matchedParticipants}
            setMatchedParticipants={setMatchedParticipants}
            mentee={isReassignOpen}
            setOpenReassignModal={setOpenReassignModal}
            setClickedMentee={setClickedMentee}
            closeModal={() => {
              setRefreshParticipants(!refreshParticipants);
              setIsReassignOpen(false);
            }}
          />
        )}

        {/* )} */}

        {isReassignOpenTeam && (
          <ReassignMentee
            matchedParticipants={matchedParticipants}
            setMatchedParticipants={setMatchedParticipants}
            program={program}
            team={teams}
            getMyTeam={getMyTeam}
            programInformation={programInformation}
            menteeId={isReassignOpenTeam}
            closeModal={(isRefresh) => {
              if (isRefresh) {
                setRefreshParticipants(!refreshParticipants);
              }
              setIsReassignOpenTeam(false);
            }}
          />
        )}

        {isDeleteMember && (
          <Modal
            title={"Are you sure you want to remove member"}
            onClose={() => setIsDeletMember(false)}
          >
            <SectionActions>
              <Button
                icon={"trash"}
                variant="danger"
                onClick={() => {
                  deleteProgram(isDeleteMember);
                }}
                text="Yes"
              />
              <ButtonSpacer />
              <Button
                // icon="tick"
                variant="primary"
                onClick={() => setIsDeletMember(false)}
                text="Cancel"
              />
            </SectionActions>
          </Modal>
        )}

        {isViewOpen && (
          <UserInfo
            userId={isViewOpen}
            closeModal={() => {
              setIsViewOpen(false);
            }}
          />
        )}
      </ActiveParticipantsContainer>
    </ActiveParticipantsWrapper>
  );
};

export default ActiveParticipants;
